import request from '@/utils/request'

export function qbFolderTree() {
  return request({ url: '/amc/qb/folder/tree', method: 'get' })
}

export function qbFolderList() {
  return request({ url: '/amc/qb/folder/list', method: 'get' })
}

export function qbCreateFolder(parentId, name) {
  const params = { name }
  if (parentId != null) params.parentId = parentId
  return request({ url: '/amc/qb/folder', method: 'post', params })
}

export function qbRenameFolder(id, name) {
  return request({ url: `/amc/qb/folder/${id}`, method: 'put', params: { name } })
}

export function qbMoveFolder(id, parentId) {
  return request({ url: `/amc/qb/folder/${id}`, method: 'put', params: { parentId } })
}

export function qbDeleteFolder(id) {
  return request({ url: `/amc/qb/folder/${id}`, method: 'delete' })
}

export function qbListFiles(folderId) {
  return request({ url: '/amc/qb/file/list', method: 'get', params: { folderId } })
}

export function qbUploadFile(folderId, file, title) {
  const form = new FormData()
  form.append('folderId', folderId)
  if (title) form.append('title', title)
  form.append('file', file)
  return request({ url: '/amc/qb/file/upload', method: 'post', data: form })
}

export function qbDeleteFile(id) {
  return request({ url: `/amc/qb/file/${id}`, method: 'delete' })
}

export function qbMoveFile(id, targetFolderId) {
  return request({ url: `/amc/qb/file/${id}/move`, method: 'put', params: { targetFolderId } })
}

export function qbPublishToCourse(fileId, courseId) {
  return request({ url: '/amc/qb/publish/file', method: 'post', params: { fileId, courseId } })
}
